import { Component, OnInit } from '@angular/core';


@Component({
	templateUrl: './adservices.component.html',
	styleUrls: ['./adservices.component.scss']
})

export class AdservicesComponent implements OnInit {

	constructor() { }

	ngOnInit() { }
}
